module.exports = __webpack_public_path__ + "static/media/dc.72142818.jpg";